/** iOS/iPadOS detection for the one thing that needs it: the install hint. */

interface NavigatorLike {
  userAgent: string;
  platform: string;
  maxTouchPoints: number;
  standalone?: boolean;
}

function nav(): NavigatorLike {
  return navigator as unknown as NavigatorLike;
}

/** iPhone, iPod, iPad — including iPadOS 13+, which reports itself as a Mac. */
export function isIos(n: NavigatorLike = nav()): boolean {
  return (
    /iPhone|iPad|iPod/.test(n.userAgent) || (n.platform === 'MacIntel' && n.maxTouchPoints > 1)
  );
}

/**
 * Safari proper on iOS — the only browser there that can add to the home
 * screen. Chrome/Firefox/Edge on iOS share the engine but not the Share sheet.
 */
export function isIosSafari(n: NavigatorLike = nav()): boolean {
  return isIos(n) && /Safari/.test(n.userAgent) && !/CriOS|FxiOS|EdgiOS/.test(n.userAgent);
}

/** iOS's own "launched from the home screen" flag; Android answers via display-mode. */
export function isStandaloneNavigator(n: NavigatorLike = nav()): boolean {
  return n.standalone === true;
}
